import { createTheme } from "@mui/material/styles";
import { cmpTheme } from "../../../theme";

export const eventDesignFont = '"DM Sans", sans-serif';

const eventChoiceControlPadding = { root: { padding: 9 }, sizeSmall: { padding: 9 } };

// The current event reference uses DM Sans.
// Keep this theme local to event authoring and management.
export const eventDesignTheme = createTheme(cmpTheme, {
  typography: { fontFamily: eventDesignFont },
  components: {
    MuiInputBase: { styleOverrides: { root: { fontFamily: eventDesignFont, fontSize: 14 } } },
    MuiTypography: { styleOverrides: { root: { fontFamily: eventDesignFont } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 8 }, notchedOutline: { borderColor: "#9E9E9E" } } },
    // The checkbox and radio look comes from cmpTheme. Event screens keep
    // MUI's 9px padding around the 18px box, as with their earlier icons.
    MuiCheckbox: { styleOverrides: eventChoiceControlPadding },
    MuiRadio: { styleOverrides: eventChoiceControlPadding },
  },
});
